<template>
  <div style="height: 100%">
    <toolbar></toolbar>
    <v-content style="height: 100%">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </v-content>
  </div>
</template>

<script>
  import toolbar from '@/components/toolbar'

  export default {
    name: 'DefaultLayout',
    components: {
      toolbar,
    }
  }
</script>
